module.exports = __webpack_public_path__ + "img/notebook_empresa.149685aa.png";